import React, { useEffect, useState, useRef } from "react";
import Slider from "react-slick";
import { useTranslation } from "react-i18next";
import axios from "axios";
import "./LatestEventsSection.css";

export default function LatestEventsSection() {
  const { t } = useTranslation();
  const sliderRef = useRef(null);

  const [images, setImages] = useState([]);
  const [slidesToShow, setSlidesToShow] = useState(3);

  // Fetch gallery images
useEffect(() => {
  axios
    .get("https://admin.cmpranesh-admk.com/api/getGalleryImages.php")
    .then((res) => {
      setImages(res.data.map(img => img.url));
    })
    .catch((err) =>
      console.log("Error loading gallery images:", err)
    );
}, []);


  // Handle responsive slide count
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;

      if (width <= 767) {
        setSlidesToShow(1);       // Mobile
      } else if (width <= 1023) {
        setSlidesToShow(2);       // Tablet
      } else {
        setSlidesToShow(3);       // Desktop
      }
    };

    handleResize(); // run on mount
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 600,
    slidesToShow,
    slidesToScroll: 1,
    autoplay: false
  };

  return (
    <section className="levents_wrapper">
      <div className="levents_container">

        <div className="levents_leftBlock">
          <p className="levents_subTitle">{t("events_sub_title")}</p>
          <h2 className="levents_title">
            {t("events_title_line1")} <br />
            {t("events_title_line2")}
          </h2>
        </div>

        <div className="levents_rightText">
          {t("events_description")}
        </div>

        <Slider ref={sliderRef} {...settings} className="levents_sliderBox">
          {images.map((img, i) => (
            <div className="levents_card" key={i}>
              <img src={img} alt="event" className="levents_image" />
            </div>
          ))}
        </Slider>

        <div className="levents_arrowsHolder">
          <div
            onClick={() => sliderRef.current?.slickPrev()}
            className="levents_prevArrow"
          >
            ←
          </div>
          <div
            onClick={() => sliderRef.current?.slickNext()}
            className="levents_nextArrow"
          >
            →
          </div>
        </div>

      </div>
    </section>
  );
}
